export const getHashParameters = () => {
  let hashString = new URL(window.location.href).hash;

  const parametersObject: Map<string, string> = new Map<string, string>();
  if (!hashString) {
    return parametersObject;
  }

  if (hashString.charAt(0) === "#") {
    hashString = hashString.substring(1);
  }

  const parameters = hashString.split(/[&#]/);

  parameters.forEach((parameter: string) => {
    let parts = parameter.split(/=(.*)/s);

    if (parts.length == 1) {
      parts = parameter.split(/-(.*)/s);
    }

    const firstPart = parts[0];
    if (firstPart) {
      parametersObject.set(
        firstPart,
        decodeURIComponent((parts[1] || "").replace(/\+/g, " ")),
      );
    }
  });

  return parametersObject;
};
